import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = ["onClick", "onKeyup"]

import {computed} from "vue";
import Card from "@/Components/General/Card.vue";
import CategoryList from "@/Pages/FAQCategories/CategoryList.vue";
import FaqCategory from "@/types/FaqCategory";
import route from "ziggy-js"
import {Inertia} from "@inertiajs/inertia";

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryBox',
  props: {
    category: {},
    selectedCategory: {},
    selected: { type: Boolean },
    returnSelected: { type: Boolean }
  },
  emits: ["selectCategory"],
  setup(__props: any, { emit }) {

const props = __props;



const selectedClasses = computed(() => {
  if (props.selected) {
    return "md:bg-gray-300 dark:bg-gray-900 dark:bg-opacity-100 focus:outline-none focus-visible:outline-black dark:focus-visible:outline-white";
  }

  return "";
})
const selectCategory = () => {
  if (props.returnSelected) {
    emit("selectCategory");
  } else {
    if (
      route().current("faq-categories.index") ||
      route().current("faq-categories.show")
    ) {
      Inertia.visit(
        route("faq-categories.show", props.category?.id as any) +
        window.location.search,
        {
          only: ["selectedCategory"],
          preserveScroll: true,
          preserveState: true,
        }
      );
    } else {
      Inertia.get(
        route("faq-categories.show", props.category?.id as any) +
        window.location.search
      );
    }
  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.category.sub_categories?.length > 0)
      ? (_openBlock(), _createBlock(CategoryList, {
          key: 0,
          selectedCategory: _ctx.selectedCategory,
          categories: [_ctx.category] as any,
          onClick: _withModifiers(selectCategory, ["stop"]),
          onKeyup: _withKeys(selectCategory, ["enter"])
        }, null, 8, ["selectedCategory", "categories", "onClick", "onKeyup"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _withModifiers(selectCategory, ["stop"]),
          onKeyup: _withKeys(selectCategory, ["enter"]),
          class: _normalizeClass(["grid border-0 status-box gap-2 cursor-pointer transform transition-all duration-200 place-content-center bg-slate-100 border border-gray-200 dark:border dark:border-gray-900 h-10 p-4", selectedClasses.value])
        }, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.category.title), 1)
        ], 42, _hoisted_2))
  ]))
}
}

})